// The sales lead a signup link carries: beuapp.com/start?deal=<leadId> (Beu HQ
// Sales). Read from the URL on any signup screen, kept for the tab
// (sessionStorage) so it survives /signup -> /signup/professional and a reload
// mid-wizard, and sent with the register call as `dealId` so core can link the
// new account back to the lead. Same shape core accepts
// ([A-Za-z0-9._:-]{8,200}); anything else is ignored. Never blocks signup.
const KEY = 'beuSignupDeal';
const DEAL_RE = /^[A-Za-z0-9._:-]{8,200}$/;

const valid = (v) => (typeof v === 'string' && DEAL_RE.test(v.trim()) ? v.trim() : null);

/** Store a valid ?deal= from the current URL (or `search`). Returns the deal in force, or null. */
export function captureSignupDeal(search) {
  let fromUrl = null;
  try {
    fromUrl = valid(new URLSearchParams(search != null ? search : window.location.search).get('deal'));
  } catch (e) { /* no URL to read */ }
  if (fromUrl) {
    try { window.sessionStorage.setItem(KEY, fromUrl); } catch (e) { /* storage blocked: the URL still has it */ }
    return fromUrl;
  }
  return getSignupDeal();
}

/** The deal for this signup: the URL's, else the one kept for this tab, else null. */
export function getSignupDeal() {
  try {
    const fromUrl = valid(new URLSearchParams(window.location.search).get('deal'));
    if (fromUrl) return fromUrl;
  } catch (e) { /* ignore */ }
  try { return valid(window.sessionStorage.getItem(KEY)); } catch (e) { return null; }
}

/** After the account exists: a later signup in this tab is not from that link. */
export function clearSignupDeal() {
  try { window.sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ }
}
